import { signIn } from 'next-auth/client'
import { useRouter } from 'next/router'
import Btn from 'components/btn/btn'

export default function SocialLogin({ register, redirect }) {
    const router = useRouter()
    let callbackUrl = router.query.r || redirect || '/'
    const type = register ? 'Registruotis' : 'Prisijungti'
    if (router.query.ref) {
        callbackUrl = `/ref?ref=${router.query.ref}`
    }

    const googleSignin = () => {
        signIn('google', { callbackUrl })
    }

    const facebookSignin = () => {
        signIn('facebook', { callbackUrl })
    }

    return (
        <>
            <Btn style="google" onClick={googleSignin} block="1" icon="btn-google">
                {type} per Google
            </Btn>
            <Btn style="facebook" onClick={facebookSignin} block="1" icon="btn-facebook">
                {type} per Facebook
            </Btn>
        </>
    )
}
